import React from 'react';
import axios from "axios";
import {Link as RouteLink} from "react-router-dom";
import {useParams,useNavigate } from "react-router-dom";
import {Box,Breadcrumb,BreadcrumbItem,BreadcrumbLink,
  
  Container,
  Stack,
  Text,
  Image,
  Flex,
  VStack,
  Button,
  Heading,
  SimpleGrid,
  StackDivider,
  useColorModeValue,
  List,
  ListItem,useToast} from "@chakra-ui/react";
import {ChevronRightIcon} from "@chakra-ui/icons";
import { MdLocalShipping } from 'react-icons/md';


function SinglePage() {
    const {id} = useParams();
    const [useDetails,setUseDetails] = React.useState({});
    const navigate = useNavigate();
    const toast = useToast()
    React.useEffect(()=>{
      axios.get(`https://server-cp.onrender.com/addData/${id}`).then((res)=>{setUseDetails(res.data)});
    },[id])
    console.log(useDetails);
    const {name,img,description,price} = useDetails;
    const handleCart = (useDetails)=>{
        axios.post(`https://server-cp.onrender.com/cart`,{
          id: Date.now() + useDetails.name,
          img: useDetails.img,
          name: useDetails.name,
          price: useDetails.price
          
        });
        toast({
          title: `Added to cart`,
          status: 'success',
          isClosable: true,
        })
        navigate("/cart");
    }

  return (
    <Box paddingTop={130}>
      <Breadcrumb spacing='8px' separator={<ChevronRightIcon color='gray.500' />}>
                <BreadcrumbItem>
                    <BreadcrumbLink href='#'><RouteLink to="/">Home</RouteLink></BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                    <BreadcrumbLink href='#'><RouteLink to="/products">Category</RouteLink></BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                    <BreadcrumbLink href='#'>Product details</BreadcrumbLink>
                </BreadcrumbItem>
        </Breadcrumb>
        <Box>
        <Container maxW={'7xl'} mt={-10}>
                    <SimpleGrid
                      columns={{ base: 1, lg: 2 }}
                      spacing={{ base: 8, md: 10 }}
                      py={{ base: 18, md: 24 }}>
                      <Flex>
                        <Image
                          rounded={'md'}
                          alt={'product image'}
                          src={img}
                          // fit={`scale-down`}
                          align={'center'}
                          w={'100%'}
                          h={{ base: '100%', sm: '400px', lg: '500px' }}
                        />
                      </Flex>
                      <Stack spacing={{ base: 6, md: 10 }}>
                        <Box as={'header'}>
                          <Heading
                            lineHeight={1.1}
                            fontWeight={600}
                            fontSize={{ base: '2xl', sm: '4xl', lg: '5xl' }}>
                            {name}
                          </Heading>
                          <Text
                            color={useColorModeValue('gray.900', 'gray.400')}
                            fontWeight={300}
                            fontSize={'2xl'}>
                            ${price} USD
                          </Text>
                        </Box>

                        <Stack
                          spacing={{ base: 4, sm: 6 }}
                          direction={'column'}
                          divider={
                            <StackDivider
                              borderColor={useColorModeValue('gray.200', 'gray.600')}
                            />
                          }>
                          <VStack spacing={{ base: 4, sm: 6 }}>
                            <Text
                              color={useColorModeValue('gray.500', 'gray.400')}
                              fontSize={'2xl'}
                              fontWeight={'300'}>
                              {description}
                            </Text>
                          </VStack>
                          <Box>
                            <Text
                              fontSize={{ base: '16px', lg: '18px' }}
                              color={useColorModeValue('yellow.500', 'yellow.300')}
                              fontWeight={'500'}
                              textTransform={'uppercase'}
                              mb={'4'}>
                              Features
                            </Text>

                            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
                              <List spacing={2}>
                                <ListItem>Chronograph</ListItem>
                                <ListItem>Master Chronometer Certified</ListItem>{' '}
                                <ListItem>Tachymeter</ListItem>
                              </List>
                              <List spacing={2}>
                                <ListItem>Anti‑magnetic</ListItem>
                                <ListItem>Chronometer</ListItem>
                                <ListItem>Small seconds</ListItem>
                              </List>
                            </SimpleGrid>
                          </Box>
                          <Box>
                            <Text
                              fontSize={{ base: '16px', lg: '18px' }}
                              color={useColorModeValue('yellow.500', 'yellow.300')}
                              fontWeight={'500'}
                              textTransform={'uppercase'}
                              mb={'4'}>
                              Product Details
                            </Text>

                            <List spacing={2}>
                              <ListItem>
                                <Text as={'span'} fontWeight={'bold'}>
                                  Between lugs:
                                </Text>{' '}
                                20 mm
                              </ListItem>
                              <ListItem>
                                <Text as={'span'} fontWeight={'bold'}>
                                  Bracelet:
                                </Text>{' '}
                                leather strap
                              </ListItem>
                              <ListItem>
                                <Text as={'span'} fontWeight={'bold'}>
                                  Case:
                                </Text>{' '}
                                Steel
                              </ListItem>
                              <ListItem>
                                <Text as={'span'} fontWeight={'bold'}>
                                  Case diameter:
                                </Text>{' '}
                                42 mm
                              </ListItem>
                              <ListItem>
                                <Text as={'span'} fontWeight={'bold'}>
                                  Dial color:
                                </Text>{' '}
                                Black
                              </ListItem>
                              <ListItem>
                                <Text as={'span'} fontWeight={'bold'}>
                                  Crystal:
                                </Text>{' '}
                                Domed, scratch‑resistant sapphire crystal with anti‑reflective
                                treatment inside
                              </ListItem>
                              <ListItem>
                                <Text as={'span'} fontWeight={'bold'}>
                                  Water resistance:
                                </Text>{' '}
                                5 bar (50 metres / 167 feet){' '}
                              </ListItem>
                            </List>
                          </Box>
                        </Stack>

                        <Button
                          onClick={()=>handleCart(useDetails)}
                          rounded={'none'}
                          w={'full'}
                          mt={8}
                          size={'lg'}
                          py={'7'}
                          bg={useColorModeValue('yellow', 'gray.50')}
                          color={useColorModeValue('black', 'gray.900')}
                          textTransform={'uppercase'}
                          _hover={{
                            transform: 'translateY(2px)',
                            boxShadow: 'lg',
                          }}>
                          Add to cart
                        </Button>

                        <Stack direction="row" alignItems="center" justifyContent={'center'}>
                          <MdLocalShipping />
                          <Text>2-3 business days delivery</Text>
                        </Stack>
                      </Stack>
                    </SimpleGrid>
                  </Container>
        </Box>
        
          
        
    </Box>
  )
}

export default SinglePage